var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    attrs: {
      processing: _vm.processing,
      buttonText: _vm.buttonText,
      variant: _vm.buttonVariant,
    },
    on: { click: _vm.toggleCompanyNotifications },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }